import { getFilterMetadata } from '../../../../components/StatelessComponent/FilterChainUtils';
import { readableRadioBooleanOperations } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioBooleanFilter/GenericRadioBooleanDropdown';
import type { RadioBooleanFilterValueType } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioBooleanFilter/GenericRadioBooleanType';
import type { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../../LabelFormatterType';

export const getValueLabel = (value: RadioBooleanFilterValueType): string => {
  if (!value) {
    return '';
  }
  return readableRadioBooleanOperations[value.operation];
};

export function getLabels(
  currentValue: RadioBooleanFilterValueType | undefined,
  filterKind: FilterKindEnum,
): LabelProps {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue),
  };
}
